<template functional>
  <div>Ops something went wrong</div>
</template>
<script>
export default {
  name: 'ItemPickerError',
};
</script>
